import { create } from 'zustand';
import { createDI } from '../../../context/di/di';
import { ApiError, useApi } from '../../../api/api';
import {AccountListReponse} from "../../../model/account_response";

/**
 * アカウント一覧画面 アクションを管理するための DI コンテキスト(アクション)
 */
export type AccountListAction = {
  /**
   * アカウント一覧取得
   */
  getAccountList: () => Promise<AccountListReponse>;


  /**
   * アカウント削除
   * @param userId
   */
  deleteAccount: (userId: number) => Promise<void>;


};

/**
 * アカウント一覧画面 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, use] = createDI<AccountListAction>();
export { Provider as AccountListProvider, use as useAccountListStore };

/**
 * アカウント一覧画面 状態とアクション
 */
export const defaultAccountListStore = () => {
  const api = useApi();

  // @ts-ignore
  return create<AccountListAction>(() => {
    return {
      getAccountList: async () => {
        const resp = await api.path('/api/accounts').get();
        if (resp.isError) {
          throw new ApiError(resp);
        }
        return resp.data as AccountListReponse;
      },

      deleteAccount: async (userId: number) => {
        const resp = await api.path(`/api/accounts/${userId}`).delete();
        if (resp.isError) {
          throw new ApiError(resp);
        }
      },
    };
  });
};
